import React from "react";
import {LinearProgress, Stack, Typography} from "@mui/material";
import {ISeasonsChapters} from "../types";
import styles from "./CardSerials.module.css";
import {ISerialData, openVideoPlayer} from "../../../store/player/playerSlice";
import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";
import clsx from "clsx";

interface IProps {
    data?: ISeasonsChapters;
    season_number?: number;
    chapters?: ISerialData[] | any
    seasons?: ISerialData[] | any
    watchingAtMinute?: number | null
    watchingSeason?: number | null
    watchingChapter?: number | null
    activeChapterNumber?: number | null
}

const CardSerials: React.FC<IProps> = ({
    data,
    seasons,
    chapters,
    season_number,
    watchingAtMinute,
    watchingSeason,
    watchingChapter,
    activeChapterNumber,
}) => {
    const {id} = useParams();
    const dispatch = useDispatch();

    const handleOpenPlayVideo = () => {
        if (data?.video && id) {
            dispatch(openVideoPlayer({
                id: Number(id),
                title: data?.title || "",
                name: data?.title || "",
                type: "SERIE",
                poster_path: data?.poster,
                videoData: data?.video,
                // Include serial data if needed
                    serialData: {
                        seasons,
                        chapters,
                        episodeTitle: data?.title,
                        seasonNumber: season_number as number, // Assuming data has season_number
                        episodeNumber: data?.chapter_number,
                    },
                    watchingAtMinute: watchingAtMinute ?? 0,
                    enabledResume:
                        Number(watchingAtMinute ?? 0) > 0 &&
                        watchingSeason === season_number &&
                        watchingChapter === data?.chapter_number,
                }));
        }
    };
    const isActiveChapter = data?.chapter_number === activeChapterNumber;

    return (
        <Stack direction={"row"} alignItems={"center"} gap={4} onClick={handleOpenPlayVideo} className={styles.root}>
            <div className={styles.card}>
                <img
                    src={data?.poster}
                    alt={"MovieItem"}
                    loading={"lazy"}
                    className={clsx(styles.poster, isActiveChapter && styles.poster_active)}
                />
                {data?.chapter_number === 0 && (
                    <div className={styles.progress_wrapper}>
                        <LinearProgress variant="determinate" value={25} className={styles.progress}/>
                    </div>
                )}
            </div>
            <Stack gap={"40px"} className={styles.root_right}>
                <Stack gap={2}>
                    <Typography variant={"h5"}>Episode {Number(data?.chapter_number)}</Typography>
                    <Typography variant={"h2"}>{data?.title}</Typography>
                </Stack>
                <Typography variant={"h5"}>{data?.duration}</Typography>
            </Stack>
        </Stack>
    );
};

export default CardSerials;
